export default function () {
    var formData = {
        Products: [{
            "product": "Annuities",
            "hint": "I purchased a Symetra annuity contract."
        }, {
            "product": "Life Insurance",
            "hint": "I purchased a Symetra life insurance policy."
        }, {
            "product": "Retirement Plans",
            "hint": "I have a Symetra IRA, 401(k), 403(b) or 457 plan."
        }]
    };

    $.each(formData.Products, function (key, value) {
        $("#product-dropdown").append($('<option></option>').val(value.hint).html('<p>'+ value.product+ '</p>'));
    });

    $('#product-dropdown').change(function () {
        var firstOptionSelected = $(this)[0].selectedIndex == 0;
        if (firstOptionSelected) {
            $('#type-dropdown').prop('disabled', true);
            $('#action-dropdown').prop('disabled', true);
        } else {
            $('#type-dropdown').prop('disabled', false);
        }
        $('.FindAFormBlock-description').html($(this).val());
    });
}